import { Layout } from 'src/components/Layout';
import { EscrowInvitationDialogContainer } from 'src/containers/EscrowInvitationDialog';

import SidebarContainer from './Sidebar/SidebarContainer';

const LayoutContainer: React.FunctionComponent = () => {
  return (
    <>
      <Layout sidebar={SidebarContainer} />
      <EscrowInvitationDialogContainer />
    </>
  );
};

export default LayoutContainer;
